/* eslint-disable */
// tslint:disable
/**
 * Isletnet API
 *  # Islets  Rest API for [IsletNet](http://isletnet.com/) - an accurate neural network based tool for automated segmentation and analysis  of pancreatic (Langerhans) islets. For more information, see the IsletNet [User guide](http://isletnet.com/guide) or try the tool at  [www.isletnet.com](http://isletnet.com/).  Both IsletNet and this API serve for two main usecases:  ## Analysis   The main usecase.   User submits a request:   - images of the tissue AND/OR own segmentations (can be mixed) - user input data (information about batch of images)   The API returns the response containing: - automated segmentation of islets for each submitted image of the tissue  - histogram of islet size distribution for each image - results of the analysis (both detailed results per image and overall summary)  ## Validation  The usecase to assess the accuracy of one\'s own segmentation by submitting both the segmentation and the  original image. The API returns the comparison of his segmentation to the automated one, returning both  visual and statistical summary.  User submits a request:  - image&own_segmentation (mask) pairs  The API returns the response containing: - results of validation against the automated segmentation - visual comparison 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BatchMetadata,
    BatchMetadataFromJSON,
    BatchMetadataFromJSONTyped,
    BatchMetadataToJSON,
    Pix2PixSummaryRequestItem,
    Pix2PixSummaryRequestItemFromJSON,
    Pix2PixSummaryRequestItemFromJSONTyped,
    Pix2PixSummaryRequestItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface Pix2PixBatchRequestItem
 */
export interface Pix2PixBatchRequestItem {
    /**
     * 
     * @type {BatchMetadata}
     * @memberof Pix2PixBatchRequestItem
     */
    batchMetadata: BatchMetadata;
    /**
     * 
     * @type {Array<Pix2PixSummaryRequestItem>}
     * @memberof Pix2PixBatchRequestItem
     */
    requests: Array<Pix2PixSummaryRequestItem>;
}

export function Pix2PixBatchRequestItemFromJSON(json: any): Pix2PixBatchRequestItem {
    return Pix2PixBatchRequestItemFromJSONTyped(json, false);
}

export function Pix2PixBatchRequestItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): Pix2PixBatchRequestItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'batchMetadata': BatchMetadataFromJSON(json['batch_metadata']),
        'requests': (json['requests'] as Array<any>).map(Pix2PixSummaryRequestItemFromJSON),
    };
}

export function Pix2PixBatchRequestItemToJSON(value?: Pix2PixBatchRequestItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'batch_metadata': BatchMetadataToJSON(value.batchMetadata),
        'requests': (value.requests as Array<any>).map(Pix2PixSummaryRequestItemToJSON),
    };
}


